<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-vola-dialog-create
          v-if="$hasPermissionTo(['create volas'])" 
          @created="loadVolas"
        />
      </v-col>

      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="VOLA's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in VOLA here"
          append-icon="search"
          label="Search VOLA"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredVolas"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.description="{ item }">
        <div
          v-if="item.description"
          v-html="item.description"
        />
        <div v-else>
          N/A
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-payroll-vola-dialog-edit
            v-if="$hasPermissionTo(['update volas'])"
            :vola="item" 
            @updated="refreshData"
          />
          <span class="mx-1" />

          <setup-payroll-vola-dialog-delete
            v-if="$hasPermissionTo(['delete volas'])"
            :vola="item"
            @deleted="refreshData"
          />
        </span>
        <span v-else>
          <setup-payroll-vola-dialog-restore
            v-if="$hasPermissionTo(['restore volas'])"
            :vola="item"
            @restored="refreshData"
          />
        </span>
      </template>
    </v-data-table> 
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollVolaDialogCreate: () => import('@/components/hris/setup/payroll/vola/DialogCreate'),
      SetupPayrollVolaDialogEdit: () => import('@/components/hris/setup/payroll/vola/DialogEdit'),
      SetupPayrollVolaDialogDelete: () => import('@/components/hris/setup/payroll/vola/DialogDelete'),
      SetupPayrollVolaDialogRestore: () => import('@/components/hris/setup/payroll/vola/DialogRestore'),
    },
    data () {
      return {
        volas: [],
        trashedVolas: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredVolas () {
        return this.statusFilter ? this.volas : this.trashedVolas
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadVolas () {
        this.$api.benefitInKinds().list('?filter[type]=vola')
          .then(response => {
            this.volas = response.data
            this.tableLoading = false
          })
      },
      loadTrashedVolas () {
        this.$api.benefitInKinds().listTrashed('?filter[type]=vola')
          .then(response => {
            this.trashedVolas = response.data
          })
      },
      refreshData () {
        this.loadVolas()
        this.loadTrashedVolas()
      },
    },
  }
</script>
